import ApiServices, {LOAD_MANAGE_MERCHANTS} from "../config/ApiServices";
import api from "../utils/api";
import store from "../store";
import {setManageMerchant} from "../store/merchant";

export class LoadManageMerchantEvent {
    params = {};

    constructor (params = null) {
        this.params = params;
    }

    static getEventName () {
        return 'LoadManageMerchantEvent';
    }
}

export class LoadManageMerchantEventListener {
    async handle (event) {
        let apiServices = ApiServices;
        let res = await api(apiServices[LOAD_MANAGE_MERCHANTS]['apiName'], event.params);
        if (res['status']) {
            let merchants = res['data'];
            let paginate = res['meta']['paginate'];
            store.dispatch(setManageMerchant({
                merchants: merchants.map((item) => {
                    item['merchantId'] = item['id'];
                    return item;
                }),
                currentPage: paginate['currentPage'],
                totalCount: paginate['manageMerchantCount'],
                totalPage: paginate['totalPage'],
            }));
        }
    }

    async after (event) {

    }
}